var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.count),function(index){return _c('div',{key:index,staticClass:"circle-tab",class:{selected: _vm.isSelected(index)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }